export interface PalletLabelCacheService {
  storePalletData(data: any): Promise<string>;
  retrievePalletData(id: string): Promise<any>;
}

class PalletLabelCacheServiceImpl implements PalletLabelCacheService {
  private baseUrl: string;

  constructor() {
    this.baseUrl = process.env.REACT_APP_PALLET_LABEL_CACHE_API_URL || "";
    if (!this.baseUrl) {
      console.warn(
        "REACT_APP_PALLET_LABEL_CACHE_API_URL not configured. Pallet label caching will not work."
      );
    }
  }

  async storePalletData(data: any): Promise<string> {
    if (!this.baseUrl) {
      throw new Error("Pallet label cache API URL not configured");
    }

    const response = await fetch(`${this.baseUrl}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ data }),
    });

    if (!response.ok) {
      const errorData = await response.json().catch((e) => {
        console.error("Failed to parse error response:", e.message, e.stack, e);
        return e;
      });
      throw new Error(
        errorData.error || `HTTP ${response.status}: ${response.statusText}`
      );
    }

    const result = await response.json();
    return result.id;
  }

  async retrievePalletData(id: string): Promise<any> {
    if (!this.baseUrl) {
      throw new Error("Pallet label cache API URL not configured");
    }

    const response = await fetch(`${this.baseUrl}/${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      if (response.status === 404) {
        throw new Error("Cache entry not found or expired");
      }
      const errorData = await response.json().catch((e) => {
        console.error("Failed to parse error response:", e.message, e.stack, e);
        return e;
      });
      throw new Error(
        errorData.error || `HTTP ${response.status}: ${response.statusText}`
      );
    }

    const result = await response.json();
    return result.data;
  }
}

// Export singleton instance
export const palletLabelCacheService = new PalletLabelCacheServiceImpl();
